/* ============================================================
 * BUECHERGLANZ.DE — Custom JavaScript
 * File: assets/custom.js
 * Version: 2.0 (Production)
 * Last updated: 2026-04-03
 * Author: buecherglanz.de Development
 *
 * PURPOSE:
 * Custom interactive behaviors not available via theme settings.
 * Loaded after theme JS via Refresh theme auto-load mechanism.
 *
 * CONTENTS:
 * 1. Product Accordion — Exclusive open (one-at-a-time)
 * 2. Back to Top Button — Scroll-triggered, smooth return
 *
 * NO jQuery dependency. Vanilla JS only.
 * ============================================================ */
document.addEventListener('DOMContentLoaded', () => {

  /* ----------------------------------------------------------
   * 1. PRODUCT ACCORDION — Exclusive open behavior
   * When one collapsible tab opens, all others close.
   * Smooth-scrolls to the opened tab with sticky header offset.
   * Targets: .product__accordion details elements on PDP
   * ---------------------------------------------------------- */
  const accordions = document.querySelectorAll('.product__accordion details');
  accordions.forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        accordions.forEach(other => {
          if (other !== detail && other.open) {
            other.removeAttribute('open');
          }
        });
        setTimeout(() => {
          const summary = detail.querySelector('summary');
          const headerHeight = document.querySelector('sticky-header, header')?.offsetHeight ?? 0;
          const top = summary.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
          window.scrollTo({ top, behavior: 'smooth' });
        }, 100);
      }
    });
  });

  /* ----------------------------------------------------------
   * 2. BACK TO TOP BUTTON
   * Creates a floating button (bottom-right) that appears
   * after 600px of scroll. Uses CSS class .bg-back-to-top
   * defined in custom.css Section 15.
   * ---------------------------------------------------------- */
  const backToTop = document.createElement('button');
  backToTop.className = 'bg-back-to-top';
  backToTop.setAttribute('aria-label', 'Nach oben scrollen');
  backToTop.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 15l-6-6-6 6"/></svg>';
  document.body.appendChild(backToTop);

  window.addEventListener('scroll', () => {
    backToTop.style.display = window.scrollY > 600 ? 'flex' : 'none';
  }, { passive: true });

  backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ----------------------------------------------------------
   * 3. MOBILE COUNTRY SELECTOR — overflow fix
   * Dawn's menu drawer clips the disclosure dropdown.
   * On open: set overflow visible. On close: restore hidden.
   * ---------------------------------------------------------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.menu-drawer__utility-links .disclosure__button');
    if (!btn) return;
    const drawer = document.querySelector('.menu-drawer');
    const inner = document.querySelector('.menu-drawer__inner-container');
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    // aria-expanded wird NACH dem Click gesetzt → kurz warten
    setTimeout(() => {
      const nowOpen = btn.getAttribute('aria-expanded') === 'true';
      if (drawer) drawer.style.overflow = nowOpen ? 'visible' : '';
      if (inner) inner.style.overflow = nowOpen ? 'visible' : '';
    }, 10);
  });

});
